import { CategoryOption } from './components/Categories';
import { OfferWallBrands, OfferWallCategories } from './types';

export const getBrandsToShow = (
  categories: OfferWallCategories[],
  selectedCategory: CategoryOption,
  allBrands: OfferWallBrands[],
  searchKey: string
) => {
  if (searchKey) {
    return allBrands.filter((brand) =>
      brand?.name?.trim().toLowerCase().includes(searchKey.trim().toLowerCase())
    );
  }
  return categories.find((item) => item?.id === selectedCategory.value)?.brands;
};

export const getUniqueList = <T>(list?: T[]) => {
  return Array.from(new Set(list)) as T[];
};
